"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _addGoods = _interopRequireDefault(require("./addGoods.vue"));
var _goodsListActive = require("@/api/operationManagement/goodsListActive");
var _brandSelection = require("@/api/brandSelection");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GoodsPop',
  components: {
    addGoods: _addGoods.default
  },
  data: function data() {
    return {
      tagUrl: '',
      listLoading: false,
      dialogVisible: false,
      goodsId: '',
      goodsName: '',
      brandId: '',
      taskId: '',
      typeList: [],
      goodsType: '',
      status: '',
      statusList: [{
        label: '有效',
        value: 1
      }, {
        label: '失效',
        value: 0
      }],
      moreBoole: false,
      page: 1,
      limit: 10,
      total: 0,
      list: []
    };
  },
  created: function created() {},
  methods: {
    delMore: function delMore() {
      if (this.list.filter(function (i, m) {
        return i.isShow;
      }).length > 0) {
        this.del(this.list.filter(function (i, m) {
          return i.isShow;
        }).map(function (obj) {
          return obj.id;
        }));
      } else {
        this.$message({
          type: 'error',
          message: '请选择商品'
        });
      }
    },
    noMore: function noMore() {
      var _this = this;
      this.$confirm('确认要取消多选？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.list.map(function (i, m) {
          i.isShow = false;
        });
        _this.moreBoole = false;
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    btnClick: function btnClick(val) {
      console.log(val);
      val.isShow = !val.isShow;
    },
    clearSearch: function clearSearch() {
      this.goodsId = '';
      this.goodsName = '';
      this.status = '';
      this.page = 1;
      this.getList();
    },
    add: function add() {
      this.$refs.addGoods.open({
        brandId: this.brandId,
        taskId: this.taskId
      });
    },
    del: function del(val) {
      var _this2 = this;
      this.$confirm('确认删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _brandSelection.del_goods)({
          idList: val
        }).then(function (res) {
          if (res.data) {
            _this2.$message({
              type: 'success',
              message: '操作成功'
            });
            _this2.getList();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    search: function search() {
      this.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _brandSelection.get_goods)({
        brandId: this.brandId,
        goodsName: this.goodsName,
        goodsId: this.goodsId,
        page: this.page,
        size: this.limit,
        status: this.status
      }).then(function (res) {
        if (res.data.data) {
          _this3.total = res.data.total;
          res.data.data.map(function (i) {
            i['isShow'] = false;
          });
          _this3.list = res.data.data;
          _this3.listLoading = false;
        }
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    open: function open(val) {
      console.log(val, '=============');
      this.brandId = val.brandId;
      this.taskId = val.taskId;
      this.getList();
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      Object.assign(this.$data, this.$options.data());
      this.dialogVisible = false;
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    // 当前分页
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    }
  }
};